export const autoscrollState = {
    defaultState: {
        autoscroll: false,
    },
    actions: {
        startAutoscroll: (_, state) => ({...state, autoscroll: true}),
        stopAutoscroll: (_, state) => ({...state, autoscroll: false}),
    },
}
